<template>
  <div>
    <el-dialog
      :title="'Chuyển sang nghỉ học: ' + fullName"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="closeDialog"
      :close-on-click-modal="false"
      top="20vh"
      custom-class="sk-dialog"
    >
      <div class="sk-dialog-content">
        <div class="sk-panel">
          <div class="sk-panel-head">
            <div class="sk-panel-icon" style="background: linear-gradient(135deg, #fbbf24, #d97706)">
              <i class="el-icon-time"></i>
            </div>
            <div>
              <p class="sk-panel-title">Xác nhận nghỉ học</p>
              <p class="sk-panel-subtitle">Chọn ngày chính thức nghỉ học cho học sinh.</p>
            </div>
          </div>
          <el-form :model="dataInput" ref="dataInput" label-width="160px">
            <el-form-item label="Chọn ngày nghỉ học" prop="date">
              <el-date-picker
                v-model="dataInput.date"
                type="date"
                value-format="yyyy-MM-dd"
                format="dd-MM-yyyy"
                placeholder="Chọn ngày"
                :clearable="false"
                :picker-options="pickerOptions"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer sk-dialog-footer">
        <el-button class="btn-cancel" type="danger" size="medium" @click="closeDialog()">
          <i class="el-icon-circle-close" />
          <span>{{ $t("button.close") }}</span>
        </el-button>
        <el-button
          class="btn-save"
          type="success"
          size="medium"
          :loading="loadingButton"
          mini
          @click="submitForm()"
        >
          <i class="el-icon-circle-check" />
          <span>{{ $t("button.save") }}</span>
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import StudentService from "@/services/StudentService";
export default {
  props: {
    dialogVisible: null,
  },
  data() {
    return {
      fullName: "",
      dataInput: { date: "" },
      loadingButton: false,
      pickerOptions: {
        disabledDate(time) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);

          const minDate = new Date(today);
          minDate.setDate(today.getDate());

          // Disable tất cả ngày < hôm nay
          return time.getTime() < minDate.getTime();
        }
      }
    };
  },
  methods: {

    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold;";
    },
    closeDialog() {
      this.$emit("dialog-close");
      setTimeout(() => {
        this.loadingButton = false;
        this.responseList = [];
      }, 300);
    },
    submitForm() {
      this.loadingButton = true;
      StudentService.updateKidsStatus(this.dataInput)
        .then((resp) => {
          this.$message({
            message: resp.data.message,
            type: "success",
          });
          setTimeout(() => {
            this.closeDialog();
          }, 500);
        })
        .catch((err) => {
          this.$message({
            message: err.response.data.message,
            type: "error",
          });
        })
        .finally(() => {
          setTimeout(() => {
            this.loadingButton = false;
          }, 500);
        });
    },
    getKidsStatusDataInitial(id, fullName) {
      this.dataInput.date = moment(String(new Date())).format("YYYY-MM-DD");
      this.fullName = fullName;
      this.dataInput.id = id;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/sk-dialog.scss";
</style>
